import { fetchAuthSession } from "aws-amplify/auth";

export async function withAuth<T>(
  callback: (headers: { Authorization: string }) => Promise<T>,
): Promise<T> {
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString();
  if (!token) {
    throw new Error("Auth token not found");
  }
  return callback({ Authorization: `Bearer ${token}` });
}

export async function authHeaders() {
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString();
  if (!token) {
    throw new Error("Auth token not found");
  }
  return { Authorization: `Bearer ${token}` };
}
